<template lang="pug">
.mp4-modal
  b-modal(v-model="_value" :size="size" no-close-on-backdrop no-close-on-esc hide-footer)
    .default-modal-body(v-if="_value").text-center
      video.mp4-video(playsinline autoplay muted loop :src="url" type="video/mp4" controls)
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

/**
 * ### Mp4プレビューモーダル
 */
@Component
export default class Mp4Modal extends Vue {
  /** 表示可否 */
  @Prop({ required: true })
  value!: boolean;
  /** モーダルサイズ */
  @Prop({ default: () => "xl" })
  size!: string;
  /** 表示する画像のURL。S3格納の場合は先に公開URLにしておく必要がある */
  @Prop()
  url!: string;

  get _value(): boolean {
    return this.value;
  }

  set _value(newValue: boolean) {
    this.$emit("input", newValue);
    return;
  }
}
</script>

<style lang="scss" scoped>
.default-modal-body {
  .mp4-video {
    width: 100%;
    height: 83vh;
  }
}
</style>
